import React from 'react';
import { Search, User, Menu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';
import Logo from '@/components/UI/Logo';
import MegaMenu from '@/components/UI/MegaMenu';
import { Sheet, SheetTrigger } from "@/components/ui/sheet";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import SideMenu from './SideMenu';
import SubscribeDialog from '@/components/UI/SubscribeDialog';
import SearchInput from '@/components/Search/SearchInput';
import SearchResultsList from '@/components/Search/SearchResultsList';
import { useSearchLogic } from '@/hooks/useSearchLogic';


const Header = () => {
  const navigate = useNavigate();
  const { resolvedTheme } = useTheme();
  const { searchResults, isSearching, handleSearchChange, query, clearSearch } = useSearchLogic();
  const [isSubscribeDialogOpen, setIsSubscribeDialogOpen] = React.useState(false);
  const handleSubscribeOpen = () => setIsSubscribeDialogOpen(true);
  const handleSubscribeClose = () => setIsSubscribeDialogOpen(false);

  return (
    <header className={cn(
      'fixed top-0 left-0 right-0 z-50 flex items-center justify-center transition-all duration-300 h-16 md:h-[72px]',
      resolvedTheme === 'dark' ? 'bg-netflix-black' : 'bg-background'
    )}>
      <div className="container mx-auto flex items-center justify-between px-4">
        <div className="flex items-center">
          <Logo className="mr-0" />
        </div>
        
        <div className="hidden md:flex flex-grow justify-center">
          <MegaMenu />
        </div>
        
        <div className="flex items-center space-x-4">
          <Popover>
            <PopoverTrigger asChild>
              <button className="text-foreground/80 hover:text-foreground transition-colors">
                <Search size={22} />
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-96 md:w-screen md:max-w-4xl lg:max-w-6xl xl:max-w-7xl p-0 bg-background" align="end">
              <div className="p-4 space-y-4">
                <SearchInput
                  query={query}
                  onChange={handleSearchChange}
                  onClear={clearSearch}
                  placeholder="Search stories, videos, tags..."
                />
                
                {query && (
                  <div className="max-h-80 overflow-y-auto">
                    {isSearching ? (
                      <div className="text-center text-muted-foreground py-8">
                        <p>Searching...</p>
                      </div>
                    ) : searchResults.stories.length === 0 && searchResults.videos.length === 0 ? (
                      <div className="text-center text-muted-foreground py-8">
                        <p>No results found for "{query}"</p>
                      </div>
                    ) : (
                      <SearchResultsList
                        storyResults={searchResults.stories}
                        contentResults={searchResults.videos}
                        onItemClick={() => {}}
                        onTagClick={(tag) => {
                          handleSearchChange({ target: { value: tag } } as React.ChangeEvent<HTMLInputElement>);
                        }}
                      />
                    )}
                  </div>
                )}
              </div>
            </PopoverContent>
          </Popover>
          
          <button 
            className="text-foreground/80 hover:text-foreground transition-colors" 
            onClick={() => navigate('/profile')}
          >
            <User size={22} />
          </button>
          

          
          <Sheet>
            <SheetTrigger asChild>
              <button className="text-foreground/80 hover:text-foreground transition-colors">
                <Menu size={22} />
              </button>
            </SheetTrigger>
            <SideMenu onSubscribeOpen={handleSubscribeOpen} />
          </Sheet>
          <SubscribeDialog isOpen={isSubscribeDialogOpen} onClose={handleSubscribeClose} />
        </div>
      </div>
    </header>
  );
};

export default Header;